import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class GroupProfileKeys extends MainKeys {
    get place() {
        return Places.groupProfile
    }

    get groupId() {
        return this._intent.getParameterAsNumber(ParamIds.groupProfileId)
    }

    set groupId(value: number | undefined) {
        this._intent.setParameter(ParamIds.groupProfileId, value)
    }
    
    get startMonthFilter() {
        return this._intent.getParameterAsString(ParamIds.groupProfileStMoFilter)
    }

    set startMonthFilter(value: string | undefined) {
        this._intent.setParameter(ParamIds.groupProfileStMoFilter, value)
    }

    get endMonthFilter() {
        return this._intent.getParameterAsString(ParamIds.groupProfileEnMoFilter)
    }

    set endMonthFilter(value: string | undefined) {
        this._intent.setParameter(ParamIds.groupProfileEnMoFilter, value)
    }

    get pageFilter() {
        return this._intent.getParameterAsNumber(ParamIds.groupProfilePageFilter)
    }

    set pageFilter(value: number | undefined) {
        this._intent.setParameter(ParamIds.groupProfilePageFilter, value)
    }

    get limitFilter() {
        return this._intent.getParameterAsNumber(ParamIds.groupProfileLimitFilter)
    }

    set limitFilter(value: number | undefined) {
        this._intent.setParameter(ParamIds.groupProfileLimitFilter, value)
    }

    get origin() {
        return this._intent.getParameterAsString(ParamIds.groupProfileOrigin)
    }

    set origin(value: string | undefined) {
        this._intent.setParameter(ParamIds.groupProfileOrigin, value)
    }
}

export default GroupProfileKeys
